<template>
  <v-app>                                    
    <app-toolbar class="app--toolbar"></app-toolbar>                
    <app-left-drawer class="app-left-drawer"></app-left-drawer>             
    <app-content class="app--content"></app-content>                        
    <app-fab></app-fab>
    <widget-fetch></widget-fetch>                     
  </v-app> 
</template>

<script>
import AppFab from './app/Fab';
import AppToolbar from './app/Toolbar';
import AppLeftDrawer from './app/LeftDrawer';
import AppContent from './app/Content';
import WidgetFetch from './widgets/Fetch';

export default {
  name: 'app-layout',
  components: {
    AppFab,
    AppToolbar,
    AppLeftDrawer,
    AppContent,
    WidgetFetch
  }
}
</script>
